// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { rem } from "polished";
import styled from "styled-components";

import { palette, spacing, typography } from "~design-system";

import { CopyWrapper } from "../CopyWrapper/CopyWrapper";

export const OverlayHeading = styled.h2`
  ${typography.Sans24}

  color: ${palette.pine1};
  margin: 0 0 ${rem(spacing.md)};
`;

export const OverlayBody = styled(CopyWrapper)`
  margin-bottom: ${rem(spacing.xl)};

  /* Left-align the ordinal markers to match the design. The default
  CopyWrapper ol uses the browser's right-aligned markers, so multi-digit
  numbers (10, 11, …) hang left of the single digits. Replacing them with a
  counter rendered in ::before at left: 0 keeps every number flush-left with a
  hanging indent. Scoped to ol here so the bullet lists are unaffected. */
  ol {
    list-style: none;
    counter-reset: ordinal;
    padding-left: 0;

    li {
      position: relative;
      counter-increment: ordinal;
      padding-left: ${rem(spacing.xl)};
    }

    li::before {
      content: counter(ordinal) ".";
      position: absolute;
      left: 0;
    }
  }
`;
